module.exports = ".ngb-modal .modal-body {\n  position: relative;\n  padding: 0; }\n  .ngb-modal .modal-body img {\n    max-width: 600px;\n    max-height: 600px;\n    -o-object-fit: contain;\n       object-fit: contain; }\n  .ngb-modal .material-icons {\n  font-size: 46px;\n  border-radius: 50%;\n  color: #FFF;\n  cursor: pointer;\n  position: relative;\n  top: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/image-preview/image-preview.component.scss
// module id = ./src/app/image-preview/image-preview.component.scss
// module chunks = main